import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { overlayStyle } from '../../styles/common-styles';
import { getWebpImage } from '../../utils'
import './jumbotron.scss'

export default class Jumbotron extends React.Component {
  render() {
    const { title, image, alt, isForReview, subheading, isIndexPage } = this.props;
    const standfirst = subheading
    const className = classnames('jumbotron', {
      'jumbotron--review': isForReview,
      'jumbotron--index-page': isIndexPage,
    })

    return (
      <header className={className}>
        <div className="jumbotron__preview">
          <figure className="jumbotron__preview-image">
            <div className="jumbotron__overlay" style={overlayStyle} />
            <amp-img class="p-jumbotron__image" src={getWebpImage(image)} height="480" alt={alt}>
              <amp-img fallback="" class="jumbotron__image" src={image} height="480" alt={alt}></amp-img>
            </amp-img>  
          </figure>
        </div>
        <div className="jumbotron__wrapper">
          <div className="jumbotron__content">
            <div className="jumbotron__inner-content">
              <h1 className="jumbotron__title">{title}</h1>
              {!isForReview && <h3 className="jumbotron__standfirst">{standfirst}</h3>}
            </div>
          </div>
        </div>
      </header>
    )
  }
}


Jumbotron.propTypes = {
  title: PropTypes.string,
  subheading: PropTypes.string,
  image: PropTypes.string,
  isForReview: PropTypes.bool,
  isIndexPage: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/jumbotron/jumbotron.js